export const Mode = {
  VERTICAL: 'vertical',
  HORIZONTAL: 'horizontal',
} as const;

export type Mode = Union<typeof Mode>;

export const Gap = {
  SMALL: 's',
  MEDIUM: 'm',
  NONE: 'none',
} as const;

export type Gap = Union<typeof Gap>;
